<tui-tabs
	[(activeItemIndex)]="activeTabIndex"
	class="absolute top-0 left-4 right-4 h-auto"
>
	<button tuiTab type="button">
		{{ 'user.account-settings-tabs.notifications' | transloco }}
	</button>
	@if (isAdmin) {
		<button tuiTab type="button">
			{{ 'user.account-settings-tabs.reports' | transloco }}
		</button>
	}
</tui-tabs>

<section tuiContent class="mt-12">
	@switch (activeTabIndex) {
		@case (0) {
			<form [formGroup]="form" class="flex flex-col gap-4">
				<label tuiLabel>
					<input
						tuiSwitch
						size="s"
						formControlName="email"
						type="checkbox"
					/>
					<span tuiTitle>
						{{
							'user.account-settings-notifications.email-title'
								| transloco
						}}

						<span tuiSubtitle>
							{{
								'user.account-settings-notifications.email-description'
									| transloco
							}}
						</span>
					</span>
				</label>
			</form>
		}
		@case (1) {
			@if (isAdmin) {
				<form [formGroup]="form" class="flex flex-col gap-4">
					@for (reportTypeId of reportTypeIds(); track reportTypeId) {
						@if (getReportControl(reportTypeId); as control) {
							<label tuiLabel>
								<input
									tuiSwitch
									size="s"
									[formControl]="control"
									type="checkbox"
								/>
								<span tuiTitle>
									{{
										'user.account-settings-reports.digest-title-' +
											reportTypeId | transloco
									}}
									<span tuiSubtitle>
										{{
											'user.account-settings-reports.digest-description-' +
												reportTypeId | transloco
										}}
									</span>
								</span>
							</label>
						}
					}
				</form>
			}
		}
	}
</section>

<footer tuiFooter>
	<button
		tuiButton
		size="s"
		type="button"
		appearance="outline"
		(click)="onCancel()"
		[disabled]="saving()"
	>
		{{ 'action.cancel' | transloco }}
	</button>
	<button
		tuiButton
		size="s"
		type="button"
		(click)="onSave()"
		[loading]="saving()"
		[disabled]="saving()"
	>
		{{ 'action.save' | transloco }}
	</button>
</footer>
